import { render, staticRenderFns } from "./EditCompany.vue?vue&type=template&id=1c45b90c"
import script from "./EditCompany.vue?vue&type=script&lang=ts"
export * from "./EditCompany.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports